import React, { useState, useEffect, useRef } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Button,
  Form,
  Input
} from "reactstrap"
import moment from "moment"
import * as _ from "lodash"
import { desOptions } from "./const"
import { accessFlags, canValidateReport } from "../../common/accessFlags"

//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import toastr from "toastr"

import * as backend from "../../helpers/backend_helper"
import Toaster from "../../components/Common/Toaster"
import MwSelect from "../../components/Common/MwSelect"
import ReportValidationControls from "../../components/Common/ReportValidation"
import ConformationAlert from "../../common/ui/customAlert"
import { removeSaveReport, saveLocalDailyworkReport } from "store/dailyWorkReport/action"

const Report = (props: any) => {
  const todayDate = moment().format("YYYY-MM-DD")
  const [date, setDate] = useState(todayDate)
  const [timeList, setTimeList] = useState<any[]>([])
  const [first, setFirst] = useState(true)
  const [submitedByuser, setSubmitedByUser] = useState<any>()
  const [submitedBy, setSubmitedBy] = useState<any>()
  const [validation, setValidation] = useState<any>(null)
  // Per-task ✓/✗ validation, keyed by row index, shown inline next to each entry.
  const [itemState, setItemState] = useState<{ [id: string]: "yes" | "no" | undefined }>({})
  useEffect(() => { setItemState((validation && validation.items) || {}) }, [validation])
  const [reportSubmitted, setReportSubmitted] = useState(false)
  const [showSubmit, setShowSubmit] = useState(false)
  const [userList, setuserList] = useState([])
  const [remarks, setRemarks] = useState({})
  const [SubmitAlertVisible, setSubmitAlertVisible] = useState(false)

  const onSubmit = async () => {
    if (props.isAdmin) {
      submit()
    } else {
      toggleAlert()
    }
  }

  const toggleAlert = () => {
    setSubmitAlertVisible(!SubmitAlertVisible)
  }

  async function getUserOrgById(userId) {
    const { orgId } = props.selectedFactory
    try {
      const response = await backend.getUserOrgById(orgId, userId)
      if (response) {
        setSubmitedByUser(response.name)
      }
    } catch (e) { }
  }

  // get Users
  async function getUsers() {
    try {
      const orgId = props.selectedFactory["orgId"]
      const response = await backend.getUserOrg(orgId)
      setuserList(response)
    } catch (e) { }
  }

  async function getReport(dateParam?, submitedByParam?) {
    // console.log("get report ", submitedByParam, submitedBy)
    if (!props.selectedFactory) return;
    const { orgId, _id: facId } = props.selectedFactory
    try {
      const response = await backend.getDailyworkReport(
        orgId,
        facId,
        dateParam ? dateParam : date,
        submitedByParam ? submitedByParam : submitedBy
      )
      if (response) {
        if (response.remarks) {
          let remarksUpdate = {
            ...remarks,
            [response.date]: response.remarks,
          }
          setRemarks(remarksUpdate)
        }
        if (response.timeList) {
          setTimeList(response.timeList)
        }
        setValidation(response.validation || null)
        if (response.submitedBy) {
          getUserOrgById(response.submitedBy)
          setReportSubmitted(true)
          setShowSubmit(false)
        } else {
          setReportSubmitted(false)
          setShowSubmit(!props.readOnly)
        }
        if (props.isAdmin) {
          setShowSubmit(!props.readOnly)
        }
      } else {
        setShowSubmit(!props.readOnly)
        setTimeList([{}])
        setSubmitedByUser(null)
        setReportSubmitted(false)
        setValidation(null)
        RetriveSaveDate(dateParam)
      }
    } catch (e) {
      // console.log("error report", e)
      setTimeList([{}])
      setSubmitedByUser(null)
      setReportSubmitted(false)
      setValidation(null)
    }
  }

  useEffect(() => {
    if (first && props.selectedFactory) {
      getReport()
      getUsers()
      setTimeList([{}])
      setFirst(false)
    }
  }, [first, props.selectedFactory])

  const _getReport = async() => {
    await getReport(null, props.isAdmin ? submitedBy : props.user._id)
  }

  useEffect(() => {
    // console.log("triggerrrrrrr", props)
    _getReport();
    // await getReport(null, props.isAdmin ? submitedBy : props.user._id)
  }, [props.selectedFactory])

  // console.log("this.props", props)
  useEffect( () => {
    if (!props.isAdmin) {
      setSubmitedBy(props.user._id)
    }
    _getReport();
    // await getReport(null, props.user._id)
    RetriveSaveDate(date)
  }, [])

  const RetriveSaveDate = currentActivedate => {
    if (!props.selectedFactory) return;
    const { _id: facId } = props.selectedFactory
    if (
      props.dailyWorkReport.dailyWorkReportSave[facId] &&
      props.dailyWorkReport.dailyWorkReportSave[facId][currentActivedate] &&
      props.dailyWorkReport.dailyWorkReportSave[facId][currentActivedate]
        .date === currentActivedate
    ) {
      setTimeList(
        props.dailyWorkReport.dailyWorkReportSave[facId][currentActivedate].list
      )
    }
  }

  function handleAddRow() {
    setTimeList([...timeList, {}])
  }

  function updateListValue(value, key, listIndex) {
    const findindex = _.findIndex(
      timeList,
      (value, index) => index == listIndex
    )
    const ltimeList = [...timeList]
    if (findindex > -1) {
      ltimeList[findindex][key] = value

      if (ltimeList[findindex].startDate && ltimeList[findindex].endDate) {
        // console.log(
        //   "ltimeList[findindex]",
        //   ltimeList[findindex],
        //   moment
        //     .duration(
        //       ltimeList[findindex].startDate,
        //       ltimeList[findindex].endDate
        //     )
        //     .hours()
        // )
        let start = moment(`01/01/2021 ${ltimeList[findindex].startDate}:00`)
        let end = moment(`01/01/2021 ${ltimeList[findindex].endDate}:00`)

        // Guard against an end time at or before the start time. moment's
        // .hours() is 0 (not negative) for a sub-hour gap like 09:15 -> 09:00,
        // so the total-minutes diff must be checked, else minutes goes negative
        // and min[-15] is undefined -> duration becomes the string "0.undefined".
        if (end.diff(start, "minutes") < 0) {
          alert("End time is less than start time")
          ltimeList[findindex].endDate = ltimeList[findindex].startDate
          end = moment(`01/01/2021 ${ltimeList[findindex].endDate}:00`)
        }

        var duration = moment.duration(end.diff(moment(start)))
        var hours = duration.hours()
        var minutes = parseInt(duration.asMinutes().toString()) % 60
        let min = {
          15: "25",
          30: "50",
          45: "75",
          0: "00",
        }

        ltimeList[findindex].duration = `${hours}.${min[minutes]}`
        // console.log("hourssss", ltimeList[findindex])
        // moment
        //   .duration(
        //     `${ltimeList[findindex].startDate}:00`,
        //     `${ltimeList[findindex].endDate}:00`
        //   )
        //   .hours()
      }

      setTimeList([...ltimeList])
    }
  }

  async function submit() {
    const { orgId, _id: facId } = props.selectedFactory

    if (!props.isAdmin) {
      toggleAlert()
    }

    if (!submitedBy) {
      alert("select name")
      return 0
    }
    try {
      const data = {
        list: timeList.filter((item) => item.startDate && item.endDate && item.duration && item.scope && item.desc),
        submitedBy: submitedBy,
        remarks: remarks[date]
      }
      await backend.saveDailyworkReport(orgId, facId, date, data)
      const Removedata = {
        facId: facId,
        date: date,
      }
      props.removeSaveReport(Removedata)
      getReport()
      Toaster.success("Work Submitted Successfully")
    } catch (e) {
      console.log("eeeeee", e);

      Toaster.error("Work Submit Failed")
    }
  }

  async function save() {
    const { orgId, _id: facId } = props.selectedFactory
    if (!submitedBy) {
      alert("select name")
      return 0
    }
    try {
      const data = {
        facId: facId,
        list: timeList,
        submitedBy: submitedBy,
        date: date,
      }
      // console.log("propssssssss", props)

      props.saveLocalDailyworkReport(data)

      Toaster.success("Work Saved Successfully")
    } catch (e) {
      Toaster.error("Work Save Failed")
    }
  }

  const [downloading, setDownloading] = useState(false)
  // PDF generated by the backend (headless Chrome) and downloaded directly.
  const downloadPdf = async () => {
    setDownloading(true)
    try {
      await backend.downloadReportPdf(
        props.selectedFactory.orgId,
        props.selectedFactory._id,
        "dailywork",
        date,
        `Daily Work Report - ${String(date).split("-").reverse().join("")}.pdf`,
        submitedBy
      )
    } catch (e) {
      Toaster.error(typeof e === "string" ? e : "Download failed")
    } finally {
      setDownloading(false)
    }
  }
  if (!props.selectedFactory) {
    return <></>
  }
  let aboutDay = {
    W: "Weekly Off",
    H: "Holiday",
    A: "Audit",
  }
  // console.log("remarksremarksremarks", remarks, remarks[date])
  // let date= `${year}-${month}-${day}`

  // console.log(
  //   "todayDatetodayDatetodayDate",
  //   todayDate,
  //   date,
  //   date === todayDate
  // )
  let isToday = date === todayDate
  // Whether the current user may validate THIS report for THIS submitter (per the
  // Validation config) — so a validator can't validate their own report unless
  // they're in their own configured user list.
  const canValidateThis = canValidateReport(props.selectedFactory, props.user, "dailywork", submitedBy)
  // The validator marks each task ✓/✗ before validating; once decided everyone
  // sees the stored marks read-only. Reserve a "Check" column whenever either applies.
  const decided = !!(validation && validation.status)
  const showItemCol = (canValidateThis && reportSubmitted) || decided
  const setItem = (id: string, v: "yes" | "no") =>
    setItemState((s) => ({ ...s, [id]: s[id] === v ? undefined : v }))
  // Plain render function (NOT a nested component) so the ✓/✗ buttons update in
  // place instead of remounting on every click.
  const renderCheck = (id: string) => {
    const cur = itemState[id]
    if (decided) {
      if (!cur) return <span className="text-muted">—</span>
      return cur === "yes"
        ? <span style={{ color: "#1c8577", fontWeight: 800 }} title="OK">✓</span>
        : <span style={{ color: "#c0392b", fontWeight: 800 }} title="Issue">✗</span>
    }
    return (
      <div style={{ display: "flex", gap: 4 }}>
        <button type="button" title="OK" onClick={() => setItem(id, "yes")}
          style={{ border: "none", borderRadius: 4, cursor: "pointer", padding: "2px 9px", fontWeight: 800,
            background: cur === "yes" ? "#2ea99b" : "#eef1f4", color: cur === "yes" ? "#fff" : "#556" }}>✓</button>
        <button type="button" title="Issue" onClick={() => setItem(id, "no")}
          style={{ border: "none", borderRadius: 4, cursor: "pointer", padding: "2px 9px", fontWeight: 800,
            background: cur === "no" ? "#e07a6f" : "#eef1f4", color: cur === "no" ? "#fff" : "#556" }}>✗</button>
      </div>
    )
  }

  // A "View & Validate" user may only submit their OWN report, never on behalf of
  // another user. Admin/Edit users can submit for anyone.
  const canSubmitHere = !props.validatorOnly || String(submitedBy) === String(props.user && props.user._id)

  // Users who have the Daily Work Report assigned (Yes) in Report Scoring.
  // People set to "No" for Daily Work are hidden from the person dropdown.
  const dailyWorkAssigned = new Set(
    ((props.selectedFactory && props.selectedFactory.reportScoring) || [])
      .filter((e: any) => (e.items || []).some((it: any) => it.report === "dailywork" && Number(it.score) > 0))
      .map((e: any) => String(e.userId))
  )

  return (
    <React.Fragment>
      <div>
        <Container fluid>
          <Row>
            {/* <Col lg={2}></Col> */}
            <Col lg={10}>
              <Card>
                <CardBody>
                  {(!showSubmit || props.isAdmin) && (
                      <React.Fragment>
                        <Button
                          onClick={downloadPdf}
                          disabled={downloading}
                          style={{ margin: "12px 0px" }}
                          color="success"
                        >
                          {downloading ? "Preparing…" : "Download PDF"}
                        </Button>
                        {/* Admin review: Validate / Reject with per-task ✓ / ✗ */}
                        <ReportValidationControls
                          reportType="dailywork"
                          dateKey={date}
                          orgId={props.selectedFactory.orgId}
                          facId={props.selectedFactory._id}
                          validation={validation}
                          isAdmin={canValidateThis}
                          submitted={reportSubmitted}
                          by={{ id: props.user && props.user["_id"], name: props.user && props.user.name }}
                          submitedBy={submitedBy}
                          onChange={setValidation}
                          externalItems={itemState}
                        />
                      </React.Fragment>
                    )}

                  {/* <CardTitle className="mb-4">Horizontal form layout</CardTitle> */}
                  {/* <FormGroup className="col-lg-3" style={{float:"right"}}>
                    <Input
                      onChange={e => {
                        console.log("get eventeeeeeee",e.target.value);
                        
                      }}
                      type="select"
                      name="selectMulti"
                      // value={ ""}
                      placeholder={"Select here"}
                    >
                      <option></option>

                      {Object.keys(aboutDay).map((key, tIndex) => {
                        return (
                          <option value={key} key={tIndex}>
                            {aboutDay[key]}
                          </option>
                        )
                      })}
                    </Input>
                  </FormGroup> */}
                  <Form>
                    <FormGroup className="row mb-4">
                      <Label
                        for="horizontal-firstname-Input"
                        className="col-sm-3 col-form-Label"
                      >
                        Name
                      </Label>
                      <Col sm={9}>
                        {/* {props.user && <p>{(submitedByuser) ?  submitedByuser : props.user.name}</p>} */}
                        {props.isAdmin ? (
                          <MwSelect
                            value={submitedBy ? submitedBy : ""}
                            placeholder="Select person"
                            onChange={(val: any) => {
                              setSubmitedBy(val)
                              getReport(null, val)
                            }}
                            options={(props.selectedFactory && props.selectedFactory.teams
                              ? props.selectedFactory.teams
                              : []
                            )
                              .filter((team: any) => team.status !== false) // hide inactive staff
                              .filter((team: any) => dailyWorkAssigned.has(String(team.userId))) // Daily Work assigned (Yes)
                              .map((team: any) => {
                                const find: any = _.find(userList, ["_id", team.userId])
                                return find
                                  ? { value: team.userId, label: `${find.name} (${find.role})` }
                                  : null
                              })
                              .filter(Boolean)}
                          />
                        ) : (
                          <Input
                            readOnly
                            type="text"
                            // name="selectMulti"
                            value={`${props.user.name} (${props.user.role})`}
                            placeholder={"Select here"}
                          ></Input>
                        )}
                      </Col>
                    </FormGroup>

                    <FormGroup className="row mb-4">
                      <Label
                        for="horizontal-email-Input"
                        className="col-sm-3 col-form-Label"
                      >
                        Factory Name
                      </Label>
                      <Col sm={9}>
                        <input
                          className="form-control"
                          type="text"
                          readOnly
                          value={props.selectedFactory.name}
                          id="example-date-input"
                        />
                      </Col>
                    </FormGroup>
                    <FormGroup className="row mb-4">
                      <Label
                        for="horizontal-email-Input"
                        className="col-sm-3 col-form-Label"
                      >
                        Date
                      </Label>
                      <Col sm={3}>
                        <Flatpickr
                          className="form-control"
                          value={date}
                          options={{ dateFormat: "Y-m-d" }}
                          onChange={(dates: any, dateStr: string) => {
                            setDate(dateStr)
                            getReport(dateStr)
                          }}
                        />
                      </Col>
                      <Label
                        for="horizontal-email-Input"
                        className="col-sm-1 col-form-Label"
                        style={{ marginTop: "7px", whiteSpace: "nowrap" }}
                      >
                        Remarks
                      </Label>
                      <Col sm={5}>
                        <MwSelect
                          value={remarks[date] ? remarks[date] : ""}
                          onChange={(val: any) => {
                            // A remark day (Holiday/Weekly Off/Audit) has no work
                            // rows, and they are hidden while a remark is set. Do
                            // NOT wipe timeList here: clearing the remark should
                            // bring the user's entered rows back, not lose them.
                            setRemarks({ ...remarks, [date]: val })
                          }}
                          options={[
                            { value: "", label: "Working day (no remark)" },
                            ...Object.keys(aboutDay).map(key => ({
                              value: key,
                              label: aboutDay[key],
                            })),
                          ]}
                        />
                      </Col>
                    </FormGroup>
                    {!remarks[date] && (
                      <React.Fragment>
                        <Row>
                          <Col lg={3}>
                            <FormGroup>
                              <Label for="formrow-firstname-Input">Time</Label>
                            </FormGroup>
                          </Col>
                          <Col lg={4}>
                            <FormGroup>
                              <Label for="formrow-firstname-Input">Scope</Label>
                            </FormGroup>
                          </Col>
                          <Col lg={showItemCol ? 4 : 5}>
                            <FormGroup>
                              <Label for="formrow-firstname-Input">
                                Work Description
                              </Label>
                            </FormGroup>
                          </Col>
                          {showItemCol && (
                            <Col lg={1}>
                              <FormGroup>
                                <Label>Check</Label>
                              </FormGroup>
                            </Col>
                          )}
                        </Row>
                        {timeList.map((time, tIndex) => {
                          const findIndex = _.findIndex(
                            timeList,
                            (value, index) => index == tIndex
                          )
                          let find,
                            desList = []
                          if (findIndex > -1) {
                            find = timeList[findIndex]
                            if (find.scope && props.selectedFactory && props.selectedFactory.workReportScope) {
                              const _filterScope = _.find(props.selectedFactory.workReportScope, ['name', find.scope]);
                              desList = (_filterScope) ? _filterScope.lists : []//desOptions[find.scope]
                            }
                          }
                          // console.log("findfindfind", find && find.startDate)

                          return (
                            <Row key={tIndex} className="mb-3 pb-1">
                              <Col lg={3}>
                                <div style={{ display: "flex" }}>
                                  <Flatpickr
                                    className="form-control d-block"
                                    placeholder="start time"
                                    style={{ margin: "2px" }}
                                    value={
                                      find && find.startDate
                                        ? find.startDate
                                        : ""
                                    }
                                    onChange={async e => {
                                      let minit = moment(e[0])
                                        .format("HH:mm")
                                        .split(":")[1]
                                      if (
                                        ["15", "30", "45", "00"].includes(minit)
                                      ) {
                                        updateListValue(
                                          moment(e[0]).format("HH:mm"),
                                          "startDate",
                                          tIndex
                                        )

                                      } else {
                                        updateListValue("", "startDate", tIndex)
                                        toastr.options = {
                                          positionClass: "toast-top-right",
                                          timeOut: 5000,
                                          extendedTimeOut: 3000,
                                          closeButton: true,
                                        }
                                        toastr.error(
                                          "minute must be 15,30,45,00"
                                        )
                                      }
                                    }}
                                    options={{
                                      enableTime: true,
                                      noCalendar: true,
                                      minuteIncrement: 15,
                                      defaultHour: 9,
                                      dateFormat: "H:i",
                                      allowInput: false,
                                    }}
                                  />
                                  <Flatpickr
                                    className="form-control d-block"
                                    placeholder="end time"
                                    value={
                                      find && find.endDate ? find.endDate : ""
                                    }
                                    style={{ margin: "2px" }}
                                    onChange={e => {
                                      // console.log(
                                      //   "moment(e[0]).format()",
                                      //   moment(e[0])
                                      //     .format("HH:mm")
                                      //     .split(":")[1]
                                      // )
                                      let minit = moment(e[0])
                                        .format("HH:mm")
                                        .split(":")[1]
                                      if (
                                        ["15", "30", "45", "00"].includes(minit)
                                      ) {
                                        updateListValue(
                                          moment(e[0]).format("HH:mm"),
                                          "endDate",
                                          tIndex
                                        )
                                      } else {
                                        updateListValue("", "endDate", tIndex)
                                        toastr.options = {
                                          positionClass: "toast-top-right",
                                          timeOut: 5000,
                                          extendedTimeOut: 3000,
                                          closeButton: true,
                                        }
                                        toastr.error(
                                          "minute must be 15,30,45,00"
                                        )
                                      }
                                    }}
                                    options={{
                                      enableTime: true,
                                      noCalendar: true,
                                      minuteIncrement: 15,
                                      defaultHour: 9,
                                      dateFormat: "H:i",
                                      allowInput: false,
                                    }}
                                  />
                                </div>
                              </Col>
                              <Col lg={4}>
                                <MwSelect
                                  value={find && find.scope ? find.scope : ""}
                                  placeholder="Select scope"
                                  onChange={(val: any) =>
                                    updateListValue(val, "scope", tIndex)
                                  }
                                  options={(props.selectedFactory && props.selectedFactory.workReportScope
                                    ? props.selectedFactory.workReportScope
                                    : []
                                  ).map((op: any) => ({ value: op.name, label: op.name }))}
                                />
                              </Col>
                              <Col lg={showItemCol ? 4 : 5}>
                                <MwSelect
                                  value={find && find.desc ? find.desc : ""}
                                  placeholder="Select description"
                                  onChange={(val: any) =>
                                    updateListValue(val, "desc", tIndex)
                                  }
                                  options={(desList || []).map((op: any) => ({
                                    value: op.name,
                                    label: op.name,
                                  }))}
                                />
                              </Col>
                              {showItemCol && (
                                <Col lg={1} className="d-flex align-items-center">
                                  {renderCheck(String(tIndex))}
                                </Col>
                              )}
                            </Row>
                          )
                        })}
                      </React.Fragment>
                    )}
                    {showSubmit && !remarks[date] && canSubmitHere && (
                      <Button
                        onClick={() => {
                          handleAddRow()
                        }}
                        color="success"
                        className="mt-1"
                      >
                        Add
                      </Button>
                    )}
                  </Form>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      paddingTop: "12px",
                    }}
                  >
                    {(isToday || props.isAdmin) && canSubmitHere && (
                      <React.Fragment>
                        {!props.isAdmin && showSubmit && !remarks[date] && (
                          <Button
                            onClick={save}
                            color="success"
                            style={{ marginRight: "20px" }}
                          >
                            Save
                          </Button>
                        )}
                        {showSubmit && (
                          <Button onClick={onSubmit} color="primary">
                            Submit
                          </Button>
                        )}
                      </React.Fragment>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
            {/* <Col lg={2}></Col> */}
          </Row>
        </Container>
        <ConformationAlert
          visible={SubmitAlertVisible}
          Title={"Alert"}
          Message={"If you submit you can't do any changes in the report"}
          toggleAlert={toggleAlert}
          Submit={submit}
        />
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  // console.log("state", state)
  const { user } = state.user
  const { selected: selectedFactory } = state.factory
  const flags = accessFlags(selectedFactory)

  return {
    selectedFactory,
    user,
    ...flags,
    dailyWorkReport: state.dailyWorkReport,
  }
}

export default withRouter(
  connect(mapStateToProps, { saveLocalDailyworkReport, removeSaveReport })(
    Report
  )
)
